/** Définition de la classe Connexion*/
export default class Connexion {
  constructor(email = '', password = '') {
    this.email = email;
    this.password = password;
  }
  reset() {
    this.email = '';
    this.password = '';
  }
}
